import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

export function usePingServerMutation(options = {}) {
  return useMutation(() => {
    return http.get(HTTP_ENDPOINTS.pingServer());
  }, options);
}
